import React, { useState } from "react";
import { Media } from "reactstrap";
import yTubeIcon from "../../../public/images/youtubeIcon.svg";
import worksheetIcon from "../../../public/images/google-docs.png";
import "./simulator.scss";
import { sendPlannerDataToFeed } from "../../../actions/tutorFeedActions";
import { connect } from "react-redux";
import { withRouter } from "react-router";

const Simulator = (props) => {
  const [snackbarMessage, setsnackbarMessage] = useState("");
  const [snackbarColor, setsnackbarColor] = useState("#01ac8a");
  const [snackbar, setsnackbar] = useState(false);
  const [submitLoading, setsubmitLoading] = useState(false);
  const {
    selectedPlannerTopic,
    programId,
    slotId,
    courseId,
    plannerId,
    startButton,
    simulatorBtn,
  } = props;

  var tutorData = JSON.parse(localStorage.getItem("loginData"));
  const sendPlannerData = () => {
    setsubmitLoading(true);
    props
      .sendPlannerDataToFeed(
        programId,
        tutorData.user.id,
        courseId,
        slotId,
        plannerId,
        selectedPlannerTopic
      )
      .then((res) => {
        setsubmitLoading(false);
        setsnackbarMessage("Topics sent successfuly");
        setsnackbarColor("#01ac8a");
        setsnackbar(true);
        setTimeout(() => {
          props.history.push("/Teacherdashboard");
          window.location.reload();
          setsnackbar(false);
          setsnackbarColor("#01ac8a");
        }, 3000);
      })
      .catch((err) => {});
  };
  return (
    <div className="makeSticky animated fadeInDown">
      <div
        className={snackbar ? "show" : ""}
        id="snackbar"
        style={{ backgroundColor: snackbarColor }}
      >
        {snackbarMessage}
      </div>
      <div style={{ background: "#f0f0f0" }}>
        <label className="ml-2" style={{ color: "#6681aa" }}>
          Students will see this:
        </label>
      </div>
      <div className="simulatorBox">
        <label>You will be learning:</label> <br />
        {selectedPlannerTopic.map((item, index) => (
          <>
            <div className="directoryBorder animated fadeInDown" key={index}>
              <label>Topic(s) covered:</label>
              <br />
              <div>
                <div className="d-flex">
                  <i className="fa fa-commenting mr-2 text-success fa-2x"></i>
                  <div>
                    <label className="mb-0">{item.topicName}</label>
                    <p className="text-italic" style={{ fontSize: 12, color: "#c1c1c1" }}>
                      (Chapter: {item.chapterName})
                    </p>
                  </div>
                </div>
              </div>
              <label className="">{item.worksheet.length > 0 && "Do Worksheet(s):"}</label>
              {item.worksheet.map((worksheet, index2) => (
                <div style={{ lineHeight: 1 }} key={index2}>
                  <label className="mb-0 animated fadeInDown">
                    <Media width={20} height={20} object src={worksheetIcon} alt={worksheetIcon} />
                    <label className="onHover">{worksheet.label}</label>
                  </label>
                </div>
              ))}
              <label className="mt-2"> {item.videos.length > 0 && "Watch Video(s):"}</label>
              {item.videos.map((video, index3) => (
                <div style={{ lineHeight: 1 }} key={index3}>
                  <label className="mb-0 animated fadeInDown">
                    <Media width={20} height={20} object src={yTubeIcon} alt={yTubeIcon} />
                  </label>
                  <label className="onHover">{video.video_caption}</label>
                </div>
              ))}
            </div>
            <br />
          </>
        ))}
        <button
          className="btn btn-light zoomBtn"
          style={{ background: "#E6E9ED" }}
          disabled={true}
          // onClick={() => window.open(item.zoomlink, "_blank")}
        >
          Click to join your class online
        </button>
        {startButton || simulatorBtn ? (
          <button
            className="btn btn-success mt-5"
            disabled={submitLoading}
            onClick={() => sendPlannerData()}
          >
            Share on students' Newsfeed
            {submitLoading && (
              <div class="spinner-border spinner-border-sm ml-2" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            )}
          </button>
        ) : null}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    programNameState: state.feedTutorRed.programName,
    classStartTime: state.feedTutorRed.classStartTime,
    attendanceData: state.feedTutorRed.attendanceData,
  };
}
export default connect(mapStateToProps, {
  sendPlannerDataToFeed,
})(withRouter(Simulator));
